<div class="input-group-agenda">
    <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1">
            <fa-icon [icon]='["fas", "search"]' class="text-secondary"></fa-icon>
        </span>
    </div>
    <input #search type="text" placeholder="Buscar..." aria-label="Search" class="form-control">
</div>